import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-welcome-loader',
    imports: [MatProgressSpinnerModule],
    templateUrl: './welcome-loader.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './welcome-loader.component.scss'
})
export class WelcomeLoaderComponent {}
